// web/src/components/RequestCard.tsx — title, site, StatusBadge, age (D05).
//
// The AI-spend figure this card used to print ("$0.42") is GONE (12_CREDITS_UX.md §2,
// 02_COST_AND_CREDITS.md §2/§5: "the word 'cost' does not appear in the customer UI"). It only
// ever rendered in mock mode — the API's toSummary() has never put `costUsd` on a customer
// RunSummary — but it sat one field away from being real, and it was doing so directly above the
// credit meter, which is the number the customer is supposed to reason in. What an update cost is
// said once, in credits, in that update's chat.
import { Link } from 'react-router-dom';
import type { RunSummary } from '../lib/types';
import { StatusBadge } from './StatusBadge';
import { age } from '../lib/status';

export function RequestCard({ run }: { run: RunSummary }) {
  return (
    <Link to={`/requests/${run.id}`}
      className="block rounded-lg border border-hair bg-surface p-4 transition-transform hover:border-surface2 active:scale-[0.99]">
      <div className="flex items-start justify-between gap-3">
        <span className="min-w-0 font-medium text-ink">
          {run.displayNo != null && <span className="mr-1.5 font-head text-xs text-muted">#{run.displayNo}</span>}
          {run.title}
        </span>
        <StatusBadge status={run.status} />
      </div>
      <div className="mt-2 flex items-center gap-3 text-xs text-muted">
        {run.siteName && <span>{run.siteName}</span>}
        <span className="font-head">{age(run.updatedAt)} ago</span>
      </div>
    </Link>
  );
}
